<div class="page-one-session-content">
  <h2 style="font-size: 4em;color: #fff;"><i class="fa fa-ban" aria-hidden="true"></i></h2>
  <h3>Acceso no autorizado!.</h3>
  <h4>Por favor de click para regresar al dashboard <br><br>
    ó intente iniciar sesión con un usuario que tenga
    permisos suficientes para ingresar a esta funcionalidad.</h4>
  <a [routerLink]="['/dashboard']">
    Volver al Dashboard
  </a>
</div>
